module.exports = __webpack_public_path__ + "img/11.8e98cd33.jpg";